module.exports = __webpack_public_path__ + "media/images/logo_gottesdienst-besuchen.de-be39b6d5006b7944421836b51f1a7032.png";